/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BeneficiariesViewModel } from './BeneficiariesViewModel';
import {
    BeneficiariesViewModelFromJSON,
    BeneficiariesViewModelFromJSONTyped,
    BeneficiariesViewModelToJSON,
} from './BeneficiariesViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfBeneficiariesViewModel
 */
export interface ResultOfBeneficiariesViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfBeneficiariesViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBeneficiariesViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfBeneficiariesViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBeneficiariesViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBeneficiariesViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfBeneficiariesViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfBeneficiariesViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {BeneficiariesViewModel}
     * @memberof ResultOfBeneficiariesViewModel
     */
    data?: BeneficiariesViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfBeneficiariesViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfBeneficiariesViewModel interface.
 */
export function instanceOfResultOfBeneficiariesViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfBeneficiariesViewModelFromJSON(json: any): ResultOfBeneficiariesViewModel {
    return ResultOfBeneficiariesViewModelFromJSONTyped(json, false);
}

export function ResultOfBeneficiariesViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfBeneficiariesViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : BeneficiariesViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfBeneficiariesViewModelToJSON(value?: ResultOfBeneficiariesViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': BeneficiariesViewModelToJSON(value.data),
        'Count': value.count,
    };
}

